export const KEY_GET_DEPARTMENTS = 'get.departments.call';
export const KEY_GET_DEPARTMENT_TEAMS = 'get.department-teams.call';
export const KEY_GET_DEPARTMENT_TEAM_MEMBERS = 'get.department-team-members.call';
export const KEY_GET_DEPARTMENT_MEMBERS = 'get.department-members.call';
export const KEY_GET_DEPARTMENTS_CREDITS = 'get.departments-credits.call';
export const KEY_GET_DEPARTMENT_TEAM_CREDITS = 'get.department-team-credits.call';
export const KEY_GET_DEPARTMENTS_CREDITS_QUARTER = 'get.departments-credits-quarter.call';
export const KEY_GET_DEPARTMENT_TEAM_CREDITS_QUARTER = 'get.department-team-credits-quarter.call';
export const KEY_GET_DEPARTMENT_TEAM_DETAILS = 'get.department-team-details.call';
export const KEY_POST_CREATE_DEPARTMENT = 'post.create-department.call';
export const KEY_POST_ASSIGN_DEPARTMENT = 'post.assign-department.call';
export const KEY_POST_ASSIGN_CHECK = 'post.assign-check.call';
